module.exports = __webpack_public_path__ + "img/oncocyte.ac6b5b2e.png";